// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"4b33675f","453":"45d23fe2"}[chunkId] + ".chunk.js";
};